import { Trans } from "@lingui/react";
import type { MobilityAd } from "@mobility-item-page/types";
import { hasExchangePolicyInfo } from "src/utils/safetyElements.ts";

type Props = {
  ad: MobilityAd;
};

const ExchangePolicy = ({ ad }: Props) => {
  if (hasExchangePolicyInfo(ad) && ad.right_to_exchange_info?.description) {
    return <p className="mb-0 whitespace-pre-line">{ad.right_to_exchange_info?.description}</p>;
  }
  // Use default text (to be used for Finn) if no exchange policy info is provided
  return (
    <p className="mb-0">
      <Trans
        id="itemPageLayout.safetyElement.exchangePolicy.info"
        message="This car is sold with an exchange policy from the dealer. This means that as a buyer, you have the option to exchange it for another
			car, according to the dealer's terms. You can do this if the car you purchased for any reason does not meet your expectations or needs. This product is offered so that you as a buyer can feel
			completely confident that you will end up with the right car for your needs."
      />
    </p>
  );
};

export default ExchangePolicy;
